export const DataforsyningenToken = 'f3ecb52320902f733a433aa9945d8dc8'
